import { Compass } from "lucide-react";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";

import { ChartCard } from "@/components/ChartCard";
import { EmptyState } from "@/components/EmptyState";
import { PageHeader } from "@/components/PageHeader";

// Catch-all for unknown routes (a stale link, a typo'd serial path, a removed surface). Keeps the
// app shell intact and offers a single way back rather than dropping the user on a blank screen.
export const NotFoundPage = (): ReactNode => (
  <>
    <PageHeader
      title="Page not found"
      description="That route doesn't exist in the Hardware Hub. It may have moved, or the link was mistyped."
    />
    <ChartCard title="Nothing here">
      <EmptyState
        title="404 — no such surface"
        message="Head back to the Command Center to pick up a known view."
        icon={Compass}
      />
      <div style={{ marginTop: 14 }}>
        <Link className="insight-cta" to="/">
          Back to Command Center
        </Link>
      </div>
    </ChartCard>
  </>
);
